import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { Hitl } from '../Hitl';

export function HumanInTheLoopPage() {
  usePageTopBar({ breadcrumb: ['Human in the loop'], hideTopBar: true });
  return <Hitl />;
}
